import {
	UserClient
} from '../clients/UserClient';

export const AuthModule = {
	namespaced: true,

	state: {
		user: null,
		requestedHandshake: false,
		authMessage: null
	},
	mutations: {
		DELETE_AUTH(state) {
			state.user = null
		}
	},

	actions: {
		delete({
			commit
		}) {
			commit('DELETE_AUTH')
		},
		getUser({
			commit,
			state
		}, callbacks = {}) {
			UserClient.getUser().then((response) => {
				state.user = response.data.user;
				let callback = callbacks.success;
				callbacks.success(state);
			}).catch((err) => {
				state.user = null;
				callbacks.error(err);
			});
		}
	}
};